import React from 'react';
import { Navbar } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

//Context
import { useAuth } from '../../context/auth';

//Routes
import routes from '../../routes/views.routes';

//Assets
import iconeArvoreBranco from '../../assets/Icons/iconeArvoreBranco.png';
import "../../assets/css/navbar.css"

export default function NavBarMunicipe() {
    const { session, signOut } = useAuth();
    const navigate = useNavigate();

    //Função executada no clique do item da navbar
    const onClickItem = (route) => {

        if (session == null || session.perfil != "Municipe") {
            navigate("/auth/login");
            return;
        }
        navigate(route);
    }

    return (

        <Navbar
            expand="md"
            className='navbar'
        >
            <div className='d-flex align-items-center justify-content-between w-100'>
                <div className='d-flex align-items-center justify-content-between'>
                    <img src={iconeArvoreBranco} className='imagemArvore' />
                    {
                        routes.filter((value) => value.tipo == "municipe" && (session != null || (session == null && !value.logado))).map((value, key) => {
                            return <span key={key} className='itemNavBar' onClick={() => onClickItem(value.layout + value.path)}>{value.name}</span>
                        })
                    }
                    {session != null && <span className='itemNavBar' onClick={() => {
                        navigate("/auth/login");
                        signOut();
                    }}>SAIR</span>}
                </div>
                <span className='itemNavBar' onClick={() => navigate("/auth/login-restrito")}>ÁREA RESTRITA</span>
            </div>
        </Navbar >
    )
}